
import React from "react";
import * as ReactRouterDom from "react-router-dom";
import { Classname, DateHelper, StringHelper } from "@rivtn/noseur";
import { i18nManager } from "../../i18n";
import { Utils } from "../../../../../utils";
import styles from "../../assets/style.module.css";
import { i18nManager as globalI18nManager } from "../../../../../i18n";
import { ITournamentEdition, TeamTypesValue, TournamentStatus } from "../../../../../services";

export interface TournamentCardProps {
    tournament: ITournamentEdition;
}

function TournamentCard({ tournament: t }: TournamentCardProps) {

    const labels = i18nManager.Labels.activities;
    const isActive = t.status !== TournamentStatus.ENDED;
    const prizePools = Object.entries(t.meta?.price_pool_amounts ?? {});
    const teamType = StringHelper.toSaneSentenceFormat(Object.keys(TeamTypesValue)[t.participant_members_count] ?? `${t.participant_members_count}`);

    return (<ReactRouterDom.NavLink to={`/to/${t.tournament_id}`} target="_blank" className={styles["t-card"]}>
        <div className={styles["t-card-media"]}>
            {t.banner_url && (<img src={t.banner_url} alt={t.name} loading="lazy" />)}
            <span className={Classname.build(styles["card-badge"], { [styles["badge-muted"]]: !isActive })}>{isActive ? (<><i className="fa fa-circle" style={{ fontSize: "0.55em", verticalAlign: "middle" }} /> {labels.status_active}</>) : labels.status_past}</span>
        </div>
        <div className={styles["t-card-body"]}>
            <div className={styles["t-card-head"]}>
                {t.logo_url && (<img className={styles["t-card-logo"]} src={t.logo_url} alt="" />)}
                <div>
                    <h3 className={styles["h4"]}>{t.name}</h3>
                    <span className={styles["t-card-date"]}>{Utils.fineDate(t.dates?.tournament_start_date ? new Date(t.dates.tournament_start_date) : DateHelper.now())}</span>
                </div>
            </div>
            <div className={styles["t-card-meta"]}>
                {t.physical_address_location && (<span><i className="fa fa-map-marker-alt" /> {t.physical_address_location}</span>)}
                {!!t.participant_members_count && (<span><i className="fa fa-users" /> {teamType}</span>)}
                {t.meta?.host_name && (<span><i className="fa fa-flag" /> {t.meta.host_name}</span>)}
            </div>
            {prizePools.length > 0 && (<div className={styles["t-card-prize"]}>
                <span className={styles["t-card-prize-lbl"]}>{labels.prize_pool}</span>
                {prizePools.map(([curr, amount]) => (
                    <span key={curr} className={styles["t-card-prize-val"]}>{globalI18nManager.queryCountryCurrency(curr, "currency_code", "currency_sign")} {StringHelper.toPresentableMoneyValue(amount as number)}</span>
                ))}
            </div>)}
        </div>
    </ReactRouterDom.NavLink>);
}

export default TournamentCard;
